import { Controller } from "@hotwired/stimulus";

/**
 * Manages a shared notifications panel that works as:
 * - A right-side slide-in panel on desktop (lg+)
 * - A bottom sheet on mobile (< lg)
 *
 * The same panel element is used for both, CSS handles the positioning.
 */
export default class extends Controller {
  static targets = ["container", "backdrop", "panel"];

  declare readonly containerTarget: HTMLElement;
  declare readonly backdropTarget: HTMLElement;
  declare readonly panelTarget: HTMLElement;

  private isOpen = false;

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.containerTarget.hidden = false;

    requestAnimationFrame(() => {
      this.containerTarget.setAttribute(
        "data-notifications-panel-state",
        "open",
      );
    });

    document.body.setAttribute("data-budgeter-notifications-panel-open", "");
  }

  close() {
    this.isOpen = false;
    this.containerTarget.setAttribute(
      "data-notifications-panel-state",
      "closed",
    );
    document.body.removeAttribute("data-budgeter-notifications-panel-open");

    setTimeout(() => {
      if (!this.isOpen) {
        this.containerTarget.hidden = true;
      }
    }, 300);
  }

  disconnect() {
    document.body.removeAttribute("data-budgeter-notifications-panel-open");
  }
}
